export const ReactionsDataHooks = {
    PopoverContent: 'reactions-popover-content',
    TriggerButton: 'reactions-trigger-button',
    SubTriggerButton: 'reactions-subtrigger-button',
    ReactionLabel: `reaction-label`,
    HasReaction: 'has-reaction',
};
export const ReactionsE2eDataHooks = 'reactions-e2e-test';
export { ReactionsDataHooks as REACTIONS_DATA_HOOKS, ReactionsE2eDataHooks as REACTIONS_E2E_DATA_HOOK, };
//# sourceMappingURL=dataHooks.js.map